export const tr = {
    banners: {
        one: '{count} reklam',
        some: '{count} reklam',
        many: '{count} reklam',
        none: 'Reklamlar'
    },
    'banners-loading-failed': 'Reklam yüklenemedi',
    'go-to-banners': 'Grup reklamlarına git',
    'no-banners-available': "Sözcük grubu için banner'lar bulunamadı"
};
